import { render, staticRenderFns } from "./singleSpeed.vue?vue&type=template&id=a60b5ec0&"
import script from "./singleSpeed.vue?vue&type=script&lang=js&"
export * from "./singleSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports